import React, {
    Fragment, useCallback, useState, useContext, useRef, useEffect
} from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withRouter } from 'react-router-dom';
import { TranslatorContext } from '@jutro/locale';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import { useAuthentication, RedirectAfterLogin, AUTH_ERRORS } from 'gw-digital-auth-react';
import appConfig from 'app-config';
import { Loader, ModalNextProvider } from '@jutro/components';
import metadata from './Agentsignup.metadata.json5';
import { isEmpty, checkEmailValidity } from '../LoginUtil';
import messages from './AgentSignUpComponent.messages';
import { messages as commonMessages } from 'gw-platform-translations';
import styles from './agentsignup.module.scss';
import { useraccess } from '@jutro/components';
import SasriaAgentSignupService from '../../../capabilities/gw-capability-agentsignup-sasria/services/SasriaAgentSignupService';
import SasriaEntryPageTemplate from '../../../../applications/producer-engage-claims/src/pages/EntryPage/template/SasriaEntryPageTemplate';



const { applicationDetails } = appConfig;

function FaqSideBar(props) {
    const translator = useContext(TranslatorContext);

    const { value, enabled } = props;
    const { id, title } = value;

    const sidebarLinkStyle = classNames(styles.wizardLi, {
        [styles.wizardLiDisabled]: !enabled
    });

    return (
        <li key={id} className={sidebarLinkStyle}>
            <Link to={`/faq#${id}`}>{translator(title)}</Link>
        </li>
    );
}


function Agentsignupcomponent(props) {
    const {
        history: { location: { state } },
    } = props;

    const translator = useContext(TranslatorContext);
    const [formData, updateFormData] = useState({});
    const { location, history } = props;
    const [pageView, setPageView] = useState();
    const [pageError, updatePageError] = useState();
    const firstname = _.get(formData, 'firstname');
    const lastname = _.get(formData, 'lastname');
    const email = _.get(formData, 'emailaddress');
    const [useraccessValue, setuseraccessValue] = useState('ownclaim');
    const userData = useAuthentication();
    const [calledForEdit, isCalledForEdit] = useState(false);
    const [editFirstName, setEditFirstName] = useState();
    const [editLastName, setEditLastName] = useState();
    const [noneditableEmail, setNoneditableEmail] = useState();


    useEffect(() => {
        const calledForEditing = _.get(state, 'isCalledForEditing');
        const _firstName = _.get(state, 'firstName');
        const _lastName = _.get(state, 'lastName');
        const _emailId = _.get(state, 'emailAddress');
        const _useraccess = _.get(state, 'userAccess');
        const _firstNameFormdata = _.get(formData, 'firstname');
        const _lastNameFormData = _.get(formData, 'lastname');
        const _emailFormData = _.get(formData, 'emailaddress');
        isCalledForEdit(calledForEditing);
        setEditFirstName(_firstName);
        setEditLastName(_lastName);
        setNoneditableEmail(_emailId);
        if (calledForEditing && !_firstNameFormdata && !_lastNameFormData && !_emailFormData) {
            _.set(formData, 'firstname', _firstName);
            _.set(formData, 'lastname', _lastName);
            _.set(formData, 'emailaddress', _emailId);
            setuseraccessValue(_useraccess);
        }

        if (calledForEditing && _firstNameFormdata && _lastNameFormData && _emailFormData) {
            _.set(formData, 'firstname', _firstNameFormdata);
            _.set(formData, 'lastname', _lastNameFormData);
            _.set(formData, 'emailaddress', _emailFormData);
        }

        if (calledForEditing) {
            _.set(formData, 'emailaddress', _emailId);
        }

    }, [calledForEdit, editFirstName, editLastName, noneditableEmail, formData,useraccessValue,state])


    const handleError = (title, message) => {
        return ModalNextProvider.showAlert({
            title: title,
            message: message,
            status: 'error',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok
        }).catch(_.noop);
    };

    const onSuccessSignup = useCallback((evt) => {
        if (evt) {
            evt.preventDefault();
        }
        if (_.isUndefined(firstname) || _.isUndefined(lastname) || _.isUndefined(email)) {
            return handleError(
                messages.allMandatoryFieldsNotGivenTitle,
                messages.allMandatoryFieldsNotGivenMessage
            );
        }
        if (!checkEmailValidity(email)) {
            return handleError(
                messages.invalidEmailTitle,
                messages.invalidEmailMessage
            );
        }
        return SasriaAgentSignupService.agentSignup(firstname, lastname, email, email, null, useraccessValue, userData.user_name)
            .then((resp) => {
                history.push('/agentsignupviewlist');
            }
            )
            .catch((err) => {
                return handleError(
                    messages.cannotCreateUserTitle,
                    messages.cannotCreateUserMessage
                );
            });
    }, [email, firstname, history, lastname, userData.user_name, useraccessValue]);

    const resendPasswordLink = useCallback((evt) => {
        if (evt) {
            evt.preventDefault();
        }
        if (isEmpty(email) || !checkEmailValidity(email)) {
            return handleError(
                messages.emailmandatoryForResendTitle,
                messages.emailmandatoryForResendMessage
            );
        }
        return SasriaAgentSignupService.setPassword(email, null)
            .then((resp) => {
                if (resp.error == null) {
                    history.push('/agentsignupviewlist');
                }
            })
            .catch((err) => {
                return handleError(
                    messages.EmailIddoesnotexistTitle,
                    messages.EmailIddoesnotexistMessage
                );
            });
    }, [history, email]);

    const updateUserButton = useCallback(
        () => {
            const firstname = _.get(formData, 'firstname');
            const lastname = _.get(formData, 'lastname');
            const email = _.get(formData, 'emailaddress');
            const useraccessSet = useraccessValue;
            if (_.isEmpty(firstname) || _.isEmpty(lastname)) {
                return handleError(
                    messages.UpdateValidationTitle,
                    messages.UpdateValidationMessage
                );
            }
            return SasriaAgentSignupService.updateUser(email, firstname, lastname,useraccessSet)
                .then((resp) => {
                    if (resp.error == null) {
                        history.push('/agentsignupviewlist');
                    }
                })
        }, [history, formData, useraccessValue]
    );


    const readValue = useCallback((id, path) => _.get(formData, path), [formData]);
    const writeValue = useCallback(
        (value, path) => updateFormData({
            ...formData,
            [path]: value
        }),
        [formData]
    );

    const getUserAccess = useCallback(
        (selecteduseraccess) => {
            setuseraccessValue(selecteduseraccess);
        }, []
    );

    const resolvers = {
        resolveValue: readValue,
        resolveClassNameMap: styles,
        faqsidebar: FaqSideBar,
        resolveCallbackMap: {
            getUserAccess: getUserAccess,
            updateUserButton: updateUserButton
        }

    };



    const overrides = {
        '@field': {
            onValueChange: writeValue,
            showOptional: false
        },

        errorMsg: {
            visible: !_.isUndefined(pageError),
            message: translator(messages[pageError])
        },

        useraccessradiobutton: {
            value: useraccessValue

        },

        emailaddress: {
            readOnly: calledForEdit ? true : false,
            value: noneditableEmail
        },

        faqSideBarSteps: {
            visible: !calledForEdit ? true : false,
        },

        faqSideBar: {
            visible: !calledForEdit ? true : false,
        },

        // useraccess: {
        //     value: 'useraccess.value.code'
        // },

        CreateButtonLink: {
            visible: !calledForEdit ? true : false,
            trigger: onSuccessSignup

        },
        //not required as per R2S-182
        // Resendlink: {
        //     visible: !calledForEdit ? true : false,
        //     trigger: resendPasswordLink

        // },

        agentsignupPageTitle: {
            visible: !calledForEdit ? true : false
        },

        agentsignupUpdatePageTitle: {
            visible: calledForEdit ? true : false
        },

        updateUser: {
            visible: calledForEdit ? true : false,
            trigger: updateUserButton
        },

        actionsWrapperSingleButton: {
            className: classNames(styles.actionsWrapperSingleButton, styles.coupleButtonStyle)
        },

        heading: {
            className: classNames(styles.heading)
        },


        invalidAttemptError: {
            visible: pageView === AUTH_ERRORS.invalidAttempt
        },
        invalidEmailError: {
            visible: pageView === AUTH_ERRORS.emailNotFound
        },
    };
    return <div>{renderContentFromMetadata(metadata.pageContent, overrides, resolvers)}</div>;


}

Agentsignupcomponent.propTypes = {
    location: PropTypes.shape({
        search: PropTypes.string
    }).isRequired,
    history: PropTypes.shape({
        push: PropTypes.func
    }).isRequired
};


export default withRouter(Agentsignupcomponent);